/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Filter/view.blocks to change it.
import CarrierSelect from './CarrierSelect/index'
import PlanNumber from './PlanNumber/index'
import React from 'react'
import RegisterAction from './RegisterAction/index'
import SearchAction from './SearchAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Filter({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/Filter"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Filter.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PlanNumber
  viewPath={`${viewPath}/PlanNumber`}
/>
<CarrierSelect
  viewPath={`${viewPath}/CarrierSelect`}
/>
<div
  data-testid="Filter.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<SearchAction
  viewPath={`${viewPath}/SearchAction`}
/>
<RegisterAction
  viewPath={`${viewPath}/RegisterAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}